import {EAddress} from '../Subscribers/definitions';
import {EDeliveryStatus, EDialogStatus, EMessageDirection, EMessageSource} from './definitions';

export default {
  title: 'Сообщения диалога',
  dialog: 'Диалог',
  channel: 'канал',
  empty: 'У вас пока нет входящих сообщений',
  loadMore: 'Загрузить ещё',
  backToDialogs: 'Назад к диалогам',
  messageSource: 'Источник: {{source}}',
  initiator: 'Инициатор: {{userId}}',
  subscriber: 'Получатель',
  operator: 'Оператор',
  yesterday: 'Вчера',
  today: 'Сегодня',
  inputPlaceholder: 'Текст сообщения',
  templateOnlyPlaceholder: 'Ответить можно только шаблонным сообщением',
  templates: 'Шаблоны',
  direction: {
    [EMessageDirection.IN]: 'Входящее',
    [EMessageDirection.OUT]: 'Исходящее',
  },
  deliveryStatus: {
    [EDeliveryStatus.ENQUEUED]: 'Ожидает',
    [EDeliveryStatus.SENT]: 'Отправлено',
    [EDeliveryStatus.FAILED]: 'Не отправлено',
    [EDeliveryStatus.ACCEPTED]: 'Не отправлено',
    [EDeliveryStatus.INVALID]: 'Не отправлено',
    [EDeliveryStatus.DELIVERED]: 'Доставлено',
    [EDeliveryStatus.CANCELLED]: 'Отменено',
    [EDeliveryStatus.UNDELIVERED]: 'Не доставлено',
    [EDeliveryStatus.READ]: 'Прочитано',
    [EDeliveryStatus.EXPIRED]: 'Просрочено',
    [EDeliveryStatus.BLOCKED]: 'Заблокировано',
    [EDeliveryStatus.SUSPENDED]: 'Приостановлено',
  },
  dialogStatus: {
    [EDialogStatus.ANSWERED]: 'Отвечен',
    [EDialogStatus.UNANSWERED]: 'Не отвечен',
  },
  dialogStatusTabs: {
    ALL: 'Все диалоги',
    [EDialogStatus.UNANSWERED]: 'Ждут ответа',
  },
  dialogAnswered: 'Диалог отвечен',
  content: {
    image: 'Изображение',
    video: 'Видео',
    audio: 'Аудио',
    document: 'Документ',
    location: 'Локация',
    contact: 'Контакт',
    firstName: 'Имя',
    lastName: 'Фамилия',
    phone: 'Телефон',
    link: 'Ссылка',
    name: 'Название',
    value: 'Значение',
    replyButton: 'Ответ на кнопку',
    requestCallPermission: 'Запрос звонка',
    flow: 'Взаимодействие с Flow',
    hasButtons: 'Сообщение содержит кнопки',
    showPreview: 'Показать',
  },
  requestCallPermission: {
    1: 'Разрешить звонки',
    2: 'Временно разрешить звонки',
    3: 'Не разрешать',
  },
  clientAnswered: 'Клиент ответил',
  clientFlow: 'Клиент взаимодействовал с Flow',
  openMap: 'Открыть на карте',
  dialogsTitle: 'Диалоги',
  unknownClient: 'Неизвестный клиент',
  preview: {
    photo: '<Фото>',
    video: '<Видео>',
    audio: '<Аудио>',
    file: '<Файл>',
    voice: '<Аудио>',
    location: '<Локация>',
    contact: '<Контакт>',
    callPermissionReply: '<Ответ на запрос звонка>',
  },
  fileSizeExceeded: 'Превышен максимальный размер {{size}} mb',
  subjectLocked: 'Переписка в этом канале сейчас невозможна. Проверьте статус лицензии.',
  toLicenses: 'В лицензии',
  dialogExpired: 'Диалог завершен более 24 часов назад. Чтобы написать клиенту, используйте шаблон',
  toBroadcasts: 'В рассылки',
  clientProfile: 'Профиль клиента',
  editProfile: 'Редактировать профиль',
  clientParameters: 'Переменные получателя',
  addresses: {
    [EAddress.WHATSAPP_BSUID]: 'WA BSUID',
    [EAddress.MAX_ID]: 'Max_ID',
    [EAddress.TELEGRAM_ID]: 'Telegram_ID',
  },
  sendTemplateMessage: {
    button: 'Шаблон',
    title: 'Отправить шаблонное сообщение',
    selectTemplate: 'Выберите шаблон рассылки',
    send: 'Отправить',
  },
  search: {
    placeholder: 'Поиск по ФИО, телефону или ID',
    noResults: 'Не нашли такого получателя и диалогов',
    subscriberFoundNoDialogs:
      'Получатель есть у нас в базе, но пока не писал нам входящих сообщений.',
    notFoundCanCreate:
      'Не нашли такого получателя и диалогов. Добавьте получателя чтобы начать диалог.',
    notFoundNoInitiation:
      'У нас нет диалога с этим клиентом. Для старта диалога нужно входящее сообщение от этого получателя.',
    writeToClient: 'Написать клиенту',
    createDialog: 'Добавить получателя',
    addSubscriber: 'Добавить получателя',
    writeInAnotherChannel: 'Написать в другом канале',
  },
  createDialog: {
    titleCreate: 'Создать получателя и диалог',
    titleStartDialog: 'Создать диалог',
    phone: 'Телефон',
    firstName: 'Имя (необязательно)',
    lastName: 'Фамилия (необязательно)',
    channelLabel: 'Канал для диалога',
    channelPlaceholder: 'Выбрать',
    cancel: 'Отмена',
    create: 'Создать',
    creating: 'Секундочку, создаем диалог в новом канале',
  },
  emptyList: 'Все в порядке, вы ответили во всех диалогах с клиентами',
  newDialog: {
    title: 'У вас пока нет диалога',
    subtitle: 'Чтобы создать диалог, напишите сообщение',
  },
  sourceName: {
    [EMessageSource.FLOW]: 'Сценарии edna',
    [EMessageSource.IMHPX]: 'Chat Center',
    [EMessageSource.JIVO]: 'Jivo',
    [EMessageSource.BROADCAST]: 'Рассылка edna',
    [EMessageSource.JSON_API]: 'API',
    [EMessageSource.OUT_MESSAGE]: 'API',
    [EMessageSource.INTERNAL_API]: 'Тест',
    [EMessageSource.BROADCAST_TEST_MESSAGE]: 'Тест',
    [EMessageSource.WHATSAPP_BUSINESS_APP]: 'WhatsApp Business App',
  },
};
